import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable }  from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import FabPopover from '@/components/fabiconpopover_component.vue';
import StaffBreakPopover from '@/components/staffbreakhrspopover_component.vue';
import EditStaffBreakPopover from '@/components/editStaffBreakHrs_component.vue';
import StaffWorkPopover from '@/components/staffworkhrspopover_component.vue';
import Popover from '@/components/popover_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import ClipboardEvents from '@/components/clipboard_events_component.vue';
import { BFormDatepicker } from 'bootstrap-vue';
import Multiselect from 'vue-multiselect';
import serviceImageCropModel from '@/components/service_image_crop_model.vue';
//import { INITIAL_EVENTS, createEventId } from './event-utils';
import moment from 'moment';
import 'moment-timezone';
import utils from './utils.js';
import ClipboardEventsJS from "./handle_events_in_clipboard.js";

export default {
    name: 'Calendar',
    components: {
        FullCalendar,
        FabPopover,
        serviceImageCropModel,
        Popover,
        LoaderPopover,
        StaffBreakPopover,
        StaffWorkPopover,
        EditStaffBreakPopover,
        ClipboardEvents,
        Multiselect,
    },
    data: function () {
        return {
            non_draggable_event_to_clipboard: false,
            filter_clipboard_width : null,
            post_calendar_data: {},
            first_load_events_data: true,
            event_hover_placement:"right",
            click_staff_offline:[],
            stores: [],
            event_hover : [],
            resource_hover : [],
            fab_icon_popup  : false,
            filter_view : false,
            staff_clicked: '',
            break_start_time : '',
            break_end_time   : '',
            staff_detail_view : false,
            staff_break_popup : false,
            edit_break_popup : false,
            staff_work_popup : false,
            clipboard_events_clear_model: false,
            edit_break_id    : 0,
            edit_break_date : '',
            edit_break_staff_selected : null,
            edit_break_start_time : '',
            edit_break_end_time : '',
            edit_break_notes : '',
            edit_break_created_date:'',
            edit_break_updated_date:'',
            currentEvents: [],
            service_image_crop_model: false,
            imageBookingId: 0,
            imagePopupName: '',
            imageMultiBookId: 0,
            clipboard_block: false,
            clipboard_events: ClipboardEventsJS.check_clipboard_events('events'),
            calendar_size: 'col-12',
            previous_clipboard_button_status: '',
            cancel_bookings: sessionStorage.getItem('cancelled_bookings') || false,
            salon_options: [],
            salon_selected : JSON.parse(sessionStorage.getItem('filters_salon_selected')) || null,
            staff_selected : JSON.parse(sessionStorage.getItem('filters_staff_selected')) || [],
            service_selected : [],
            booktype_selected : 'Services',
            staff_selected_start_time : null,
            staff_selected_end_time : null,
            staff_options: JSON.parse(sessionStorage.getItem('filters_staff_options')) || [],
            service_options: [],
            status_selected: [],
            header_display:[],
            cl:'',
            original_time: false,
            show_upload_picture:true,
            adjust_calendar_size:'',
            resource_width: '',
            date_picker: '',
            status : JSON.parse(sessionStorage.getItem('filters_status')) || [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'checked' :true },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'checked' :true },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'checked' :true },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'checked' :false },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'checked' :false }
            ],
            book_status : [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'img' :'booked_icon.svg', 'color_class' : 'light_blue' },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'img' :'arrived_icon.svg', 'color_class' : 'blue' },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'img' :'completed_icon.svg', 'color_class' : 'green' },
                {'status_id' : this.Constants.STATUS_EARLY_CANCELLED , 'status_name' : 'Cancelled', 'img' :'cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'img' :'late_cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'img' :'noshow_icon.svg','color_class' : 'orange' }
            ],
            filter_status_selected : JSON.parse(sessionStorage.getItem('filters_filter_status_selected')) || [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'checked' :true },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'checked' :true },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'checked' :true }
            ],
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    resourceTimeGridPlugin,
                    interactionPlugin // needed for dateClick
                ],
                droppable: true,
                customButtons: {
                    ClipboardButton: {
                        click: this.clipboard_open
                    },
                    FilterButton: {
                        click: this.filterView
                    },
                    NextMonthButton:{
                        icon : 'fc-icon-chevrons-right',
                        click: this.nextMonth,
                    },
                    PrevMonthButton:{
                        icon : 'fc-icon-chevrons-left',
                        click: this.prevMonth,
                    },
                    TodayButton: {
                        text: 'Today',
                        click: this.todayDate,
                    },
                    DisableTodayButton: {
                        text: 'Today',
                    },
                    NextWeekButton:{
                        icon : 'fc-icon-chevrons-right',
                        click: this.nextWeek,
                    },
                    PrevWeekButton:{
                        icon : 'fc-icon-chevrons-left',
                        click: this.prevWeek,
                    },
                    Next2WeekButton:{
                        icon : 'fc-icon-chevrons-right',
                        click: this.next2Week,
                    },
                    prev:{
                        icon : 'fc-icon-chevron-left',
                        click: this.prevDate,
                    },
                    next:{
                        icon : 'fc-icon-chevron-right',
                        click: this.nextDate,
                    },
                    Prev2WeekButton:{
                        icon : 'fc-icon-chevrons-left',
                        click: this.prev2Week,
                    },
                    Next2MonthButton:{
                        icon : 'fc-icon-chevrons-right',
                        click: this.next2Month,
                    },
                    Prev2MonthButton:{
                        icon : 'fc-icon-chevrons-left',
                        click: this.prev2Month,
                    },
                    DayButton:{
                        text : 'D',
                        class: 'fc-button-active',
                        click: this.dayView,
                    },
                },
                headerToolbar: {
                    left: 'PrevWeekButton,prev title next,NextWeekButton',
                    center: '',
                    right: 'DayButton,timeGridWeek,dayGridMonth,ClipboardButton,FilterButton'
                },
                views: {
                    dayGridMonth: {buttonText: 'M'},
                    timeGridWeek: {buttonText: 'W'},
                    resourceTimeGridDay: {buttonText: 'D'},
                },
                slotLabelFormat :{
                    hour: '2-digit',
                    minute: '2-digit',
                },
                titleFormat :{ year: 'numeric', month: 'short', day: 'numeric','weekday': 'short' },
                initialView: sessionStorage.getItem('session_calendar_initial_view') ? sessionStorage.getItem('session_calendar_initial_view') : 'resourceTimeGridDay',
                initialDate: this.$store.state.selected_date,
                resourceLabelDidMount: this.resourceMount,
                resourceOrder : 'user_staff_order',
                resources: [],
                events: [],
                // eventBorderColor: '#0084F4',
                eventTextColor: '#292929',
                eventBackgroundColor: '#ffffff',
                allDaySlot: false,
                slotDuration: '00:15:00',
                snapDuration: '00:05:00',
                editable: true,
                eventResize : this.reschedule_booking,
                eventDrop: this.reschedule_booking,
                drop: this.drop_function,
                eventReceive: this.drop_card_details,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                scrollTime: this.Constants.SCROLL_TIME,
                nowIndicator: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventMouseEnter: this.eventMoreInfo,
                eventsSet: this.handleEvents,
                eventDidMount : this.handlingEventBorder,
                eventDragStop: this.drag_out_events,
                contentHeight: window.innerHeight-180,
                eventDragStart: this.handel_time_event,
                eventResizeStart: this.handel_time_event,
                windowResize:this.onSideDivResize,
                /* you can update a remote database when these fire:
                    eventAdd:
                    eventChange:
                    eventRemove:
                */
            },
            
        }
    },
    mounted() {
        this.$session.remove('editbooking')
        this.$store.state.menu_toggle = false;
        let calendarApi = this.$refs.fullCalendar.getApi();
        let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').format('YYYY-MM-DD');
        this.date_picker =new BFormDatepicker({
            propsData: {
                id: 'select_date',
                value: date,
                buttonOnly: true,
                hideHeader: true,
                // todayButton : true,
                labelNextYear : 'Next Year',
                selectedVariant : 'info',
                dateFormatOptions: {'year': 'numeric', 'month': 'short', 'day': '2-digit', 'weekday': 'short'},
                size: 'sm',
                context: this.getPickDate
            }
        }).$mount('.fc-toolbar-title').$on('context', this.getPickDate);

        let calendar_header = document.getElementsByClassName('fc-toolbar-chunk');
        calendar_header[1].style.color ="#0084F4";
        calendar_header[1].style.fontSize = "20px";
        calendar_header[1].className += " point_cursor";
        
        document.getElementsByClassName('fc-toolbar-chunk')[0].className += " point_cursor";

        this.getStore();
//        this.applyFilters();
        this.check_clipboard_on_route();
        this.filter_button(this.filter_view);
        this.clipboard_button();
        this.day_button_design();
        //this.onSideDivResize();
        this.cl = document.getElementById('calendar');
        this.cl.addEventListener('resize', this.onSideDivResize)
        this.adjust_calendar_size = document.getElementById('calendar_view');
        this.adjust_calendar_size.style.setProperty('left','70px');
        let side_bar_width = document.getElementById('sidebar').offsetWidth;
        this.adjust_calendar_size.style.setProperty('width',window.innerWidth-side_bar_width-5+'px');
    },
    computed:{
        menu_toggle(){
            return this.$store.state.menu_toggle;
        }
    },
    watch: {
        filter_view: function (status) { 
            this.filter_button(status)
        },
        menu_toggle(){
            let _this = this
            window.setTimeout( function(){
                let side_bar_width = document.getElementById('sidebar').offsetWidth;
                _this.adjust_calendar_size.style.setProperty('left',side_bar_width+'px');
                _this.adjust_calendar_size.style.setProperty('width',window.innerWidth-side_bar_width-5+'px');
                _this.onSideDivResize()
            },100)  
        },
        staff_break_popup: function (status) { 
            if(status == true) this.close_all_hover_popover()
            else this.enable_body_scroll();
        },
        edit_break_popup: function (status) { 
            if(status == true) this.close_all_hover_popover()
            else this.enable_body_scroll();
        },
        staff_work_popup: function (status) { 
            if(status == true) this.close_all_hover_popover()
            else this.enable_body_scroll();
        },
        service_image_crop_model: function (status) { 
            if(status == true) this.close_all_hover_popover()
            else {
                this.enable_body_scroll();
                this.eventRefetch();
            }
        },
        clipboard_block: function(status) {
            if(status == true) this.apply_dragable_property_to_clipboard_events();
        }
    },
    methods: {

        resourceWidth(){
            this.resource_width = document.getElementsByClassName('fc-resource')[1].clientWidth;
        },
        openDatepicker(){
            document.getElementById('select_date').click();
        },

        onSideDivResize () {
            if(this.cl.offsetWidth < 635){
                this.$router.push('/bookings');
            }

            if(this.$refs.fullCalendar){
                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.setOption('contentHeight', window.innerHeight-180);
                calendarApi.updateSize();
            }

            if(document.getElementById('clipboard') && (this.$refs.filter_div)){
                document.getElementById('filter_view').style.width = this.$refs.filter_div.clientWidth+'px';
                document.getElementById('clipboard').style.width = this.$refs.filter_div.clientWidth+'px';
            }

            if(this.$refs.filter_div){
                this.filter_clipboard_width = this.$refs.filter_div.clientWidth + 50;
            }
            else {
                this.filter_clipboard_width = 50
            }
            
            if(this.$refs.fullCalendar){

                document.getElementsByClassName('fc-toolbar-chunk')[0].childNodes[1].onclick = this.openDatepicker;

                document.getElementsByClassName('fc-toolbar-chunk')[1].onclick = this.filterView;
                
                if(this.$refs.fullCalendar.$el.clientWidth < 1100){
                    let heading =  document.getElementsByClassName('fc-toolbar-chunk')[1].innerHTML
                    heading = heading.substr(0,15) + '...'
                    document.getElementsByClassName('fc-toolbar-chunk')[1].innerHTML = heading
                }
                else{
                    this.header_title()
                    document.getElementsByClassName('fc-toolbar-chunk')[1].hidden = false
                }
            }
        },

        day_button_design(){
            
            var day_button_style = document.getElementsByClassName("fc-DayButton-button ")[0];
            let calendarApi = this.$refs.fullCalendar.getApi();
            if(calendarApi.view.type == 'resourceTimeGridDay'){
                day_button_style.style.setProperty("background","#FB6672","important")
                day_button_style.style.setProperty("color","#ffffff","important")
                day_button_style.style.setProperty("border-color","#FB6672","important")
            }
            else{
                day_button_style.style.setProperty("background","#ffffff","important")
                day_button_style.style.setProperty("color","#999999","important")
                day_button_style.style.setProperty("border-color","#EBEFF2")
            }

        },

        filter_button(status)
        {
            var filter_button_style = document.getElementsByClassName("fc-FilterButton-button")[0];
           
            if(status == true)
            {
                filter_button_style.style.setProperty("background", "url('" + require('@/assets/images/icons/filter_open.svg') + "')", "important");
            }
            else
            {
                filter_button_style.style.setProperty("background", "url('" + require('@/assets/images/icons/filter_close.svg') + "')", "important");
            }
            filter_button_style.style.setProperty("background-size", "cover", "important");

        },

        check_clipboard_on_route()
        {
            if(ClipboardEventsJS.check_clipboard_events('length') != 0)  this.clipboard_open();
            else this.minimize_clipboard();
        },

        clipboard_button_enable_or_disable(status)
        {
//            if(this.previous_clipboard_button_status != status)
//            {
                this.previous_clipboard_button_status = status;
                var clipboard_button_style = document.getElementsByClassName("fc-ClipboardButton-button")[0];
                if(status == 'disable')
                {
                    this.minimize_clipboard();
                    clipboard_button_style.disabled = true;
                    clipboard_button_style.style.cssText = "cursor:no-drop !important; border:0px !important; opacity:1 !important; background:url('" + require('@/assets/images/icons/clipboard_disable.svg') + "') !important; background-size:cover !important";
                }
                else if(status == 'enable')
                {
                    clipboard_button_style.disabled = false;
                    clipboard_button_style.style.cssText = "cursor:pointer !important; border:2px solid #EBEFF2 !important;";

                    clipboard_button_style.addEventListener('mouseover', function() {this.style.setProperty("border", "2px solid #0084F4", "important");})
                    clipboard_button_style.addEventListener('mouseout', function() {this.style.setProperty("border", "2px solid #EBEFF2", "important"); })
                    
                    this.clipboard_button()
                    if(ClipboardEventsJS.check_clipboard_events('length') != 0)
                    {
                        this.clipboard_open()
                        // this.apply_dragable_property_to_clipboard_events()
                    }
                }
//            }
        },

        clipboard_button() {
            var clipboard_button_style = document.getElementsByClassName("fc-ClipboardButton-button")[0];
            if(clipboard_button_style)
            {
                if(ClipboardEventsJS.check_clipboard_events('length') != 0)
                {
                    clipboard_button_style.style.setProperty("background", "url('" + require('@/assets/images/icons/clipboard_with_events.svg') + "')", "important");
                }
                else
                {
                    clipboard_button_style.style.setProperty("background", "url('" + require('@/assets/images/icons/clipboard_without_events.svg') + "')", "important");
                }
                clipboard_button_style.style.setProperty("background-size", "cover", "important");
            }
        },

        reschedule_booking(info){
            this.original_time = false;
            var reschedule_data = {};
            let calendarApi = this.$refs.fullCalendar.getApi();
            if(info.newResource == null){
                
                if(info.event.extendedProps.service == 'Break')
                {
                    this.edit_break_id              = info.oldEvent.id;
                    this.edit_break_date            = info.event.end;
                    this.edit_break_staff_selected  = info.oldEvent.extendedProps.staff_id;
                    this.edit_break_start_time      = info.event.start;
                    this.edit_break_end_time        = info.event.end;                
                    this.edit_break_notes           = info.event.extendedProps.booking_notes;
                    this.edit_break_popup           = true;
                }
                else{
                    if(info.event.extendedProps.book_status == 200 || info.event.extendedProps.book_status == 220){
                        this.$session.set('booking_type',this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING);
                        this.$session.set('book_id',info.oldEvent.id);
                        this.$session.set('multi_book_id',0);
                        reschedule_data ={
                            'start_time'     : moment(info.event.start).format("HH:mm"),
                            'end_time'       : moment(info.event.end).subtract({minutes:info.event.extendedProps.prebuffer_time+info.event.extendedProps.postbuffer_time}).format("HH:mm"),
                            'selected_staff' : info.oldEvent.extendedProps.staff_id,
                            'droped_date'    : info.event.end
                        }
                        this.$session.set('reschedule_data',reschedule_data);
                        this.$session.set('editbooking',true);
                        this.$router.push('/newbooking');
                    }
                    else {
                        this.non_draggable_event_to_clipboard = true;
                        calendarApi.refetchEvents();
                    }
                }
            }
            else{

                if(info.event.extendedProps.service == 'Break')
                {
                    this.edit_break_id              = info.oldEvent.id;
                    this.edit_break_date            = info.event.end;
                    this.edit_break_staff_selected  = info.newResource.id;
                    this.edit_break_start_time      = info.event.start;
                    this.edit_break_end_time        = info.event.end;                
                    this.edit_break_notes           = info.event.extendedProps.booking_notes;
                    this.edit_break_popup           = true;
                }
                else{
                    if(info.event.extendedProps.book_status == 200 || info.event.extendedProps.book_status == 220){
                        this.$session.set('booking_type',this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING);
                        this.$session.set('book_id',info.oldEvent.id);
                        this.$session.set('multi_book_id',0);
                        reschedule_data ={
                            'start_time'     : moment(info.event.start).format("HH:mm"),
                            'end_time'       : moment(info.event.end).subtract({minutes:info.event.extendedProps.prebuffer_time+info.event.extendedProps.postbuffer_time}).format("HH:mm"),
                            'selected_staff' : info.newResource.id,
                            'droped_date'    : info.event.end
                        }
                        this.$session.set('reschedule_data',reschedule_data);
                        this.$session.set('editbooking',true);
                        this.$router.push('/newbooking');
                    }
                    else {
                        this.non_draggable_event_to_clipboard = true;
                        calendarApi.refetchEvents();
                    }
                }
            }
            
           
        },

        drop_function(info){
            this.$session.set('booking_type',this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING);
            var reschedule_data ={
                'start_time'     : '',
                'end_time'       : '',
                'selected_staff' : info.resource._resource.id,
                'droped_date'    :info.dateStr
            }
            this.$session.set('reschedule_data',reschedule_data);
        },

        drop_card_details(info){
            info.revert();
            var reschedule_data = this.$session.get('reschedule_data');
            var difference = ((moment(info.event.extendedProps.end_time,["hh:mm A"]) - moment(info.event.extendedProps.start_time,["hh:mm A"]))/60)/1000
            var end_time = moment(info.event.startStr).add(difference, 'minutes')
            if(info.event.extendedProps.service == 'Break')
            {
                this.edit_break_id              = info.event.id;
                this.edit_break_date            = reschedule_data.droped_date;
                this.edit_break_staff_selected  = reschedule_data.selected_staff;
                this.edit_break_start_time      = info.event.startStr;
                this.edit_break_end_time        = end_time;                
                this.edit_break_notes           = info.event.extendedProps.booking_notes;
                this.edit_break_popup           = true;
            }

            else{
                this.$session.set('book_id',info.event.id);
                this.$session.set('multi_book_id',0);
                this.$session.set("staff_selected",true);
                this.$session.set("staff_id",reschedule_data.selected_staff);
                this.$session.set("service_start_time",moment(info.event.start).format("HH:mm"),)
                reschedule_data.start_time = moment(info.event.startStr).format("HH:mm");
                reschedule_data.end_time = moment(end_time).format("HH:mm");
                this.$session.set('reschedule_data',reschedule_data);
                if(info.event.extendedProps.clipboard_event_flag == 2){
                    this.$session.set('selected_date',info.event.startStr);
                    this.$session.set('rebook',true);
                    this.$router.push('/newbooking');
                }
                else {
                    this.$session.set('booking_type',this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING);
                    this.$session.set('editbooking',true)
                    this.$router.push('/newbooking');
                }
            }
            this.clipboard_events = ClipboardEventsJS.removeEventFromClipboard(info);
            this.clipboard_button();
        },

        drag_out_events: function(eventInfo) 
        {

            if(this.clipboard_block)
            {
                if(clipboardArea(eventInfo["jsEvent"].clientX, eventInfo["jsEvent"].clientY))
                {
                    if(eventInfo['event'].extendedProps.book_status != this.Constants.STATUS_BOOKED && eventInfo['event'].extendedProps.book_status != this.Constants.STATUS_ARRIVED)
                    {
                        this.non_draggable_event_to_clipboard = true;
                        return;
                    }
                    var new_event = 
                    {
                        id:eventInfo['event'].id,
                        date:eventInfo['event'].extendedProps.service_date,
                        vip:eventInfo['event'].extendedProps.vip, 
                        allergy:eventInfo['event'].extendedProps.allergy, 
                        fullpayment:eventInfo['event'].extendedProps.fullpayment, 
                        banned:eventInfo['event'].extendedProps.banned, 
                        book_status:eventInfo['event'].extendedProps.book_status, 
                        name:eventInfo['event'].extendedProps.name, 
                        start_time:utils.convert_datetime_to_bookjoy_time_format(eventInfo['event'].extendedProps.start_time), 
                        end_time:utils.convert_datetime_to_bookjoy_time_format(eventInfo['event'].extendedProps.end_time),
                        service:eventInfo['event'].extendedProps.service, 
                        booking_notes: eventInfo['event'].extendedProps.booking_notes,
                        last_visit_count: eventInfo["event"].extendedProps.last_visit.length,
                        clipboard_event_flag: this.Constants.CLIPBOARD_EVENT_FROM_CALENDAR
                    }
                    if(ClipboardEventsJS.create_clipboard_event(new_event) == true)
                    {
                        this.make_clipboard_event_dragable('ClipboardEvent'+new_event.id, new_event);
                    }
                    this.clipboard_events = ClipboardEventsJS.check_clipboard_events('events')
                    this.clipboard_button();
                    this.on_event_drag_to_clipboard(eventInfo)
                }
            }

        },

        on_event_drag_to_clipboard(info)
        {
            var events_in_clipboard = ClipboardEventsJS.check_clipboard_events('events');
            if (events_in_clipboard.findIndex(x => x.id == info.event.id) !== -1)
            {
                info.el.style.opacity = 0.5;
                info.el.style.boxShadow = "0 0 2px 2px #0084F4";
            }
        },

        apply_dragable_property_to_clipboard_events() 
        {
            var old_events = ClipboardEventsJS.check_clipboard_events('events');
            for (let event_card = 0; event_card < old_events.length; event_card++) 
            {
                this.make_clipboard_event_dragable('ClipboardEvent'+old_events[event_card].id, old_events[event_card])
            }
        },

        make_clipboard_event_dragable(id, event_data)
        {
            if(document.getElementById(id))
            {
                new Draggable(document.getElementById(id), { 
                    eventData: this.clipboard_event_data(event_data) 
                });
                return;
            }
            let _this = this;
            window.setTimeout(function() {
                _this.make_clipboard_event_dragable(id, event_data)
            }, 25);      
        },

        clipboard_event_data(event_data)
        {
            this.original_time = true;
            let duration = moment.duration(moment(event_data.end_time, "HH:mm").diff(moment(event_data.start_time, "HH:mm")));
            let hours = duration._data.hours;
            if(hours < 10)
                hours = '0'+hours;
            let minutes = duration._data.minutes;
            if(minutes < 10)
                minutes = '0'+minutes;
            return {
                id:event_data.id,
                date:event_data.date,
                vip:event_data.vip, 
                allergy:event_data.allergy, 
                banned:event_data.banned, 
                book_status:event_data.book_status, 
                name:event_data.name,
                start_time:event_data.start_time,
                startTime:event_data.start_time,
                duration:hours+":"+minutes,
                end_time:event_data.end_time,
                service:event_data.service,
                booking_notes:event_data.booking_notes,
                last_visit_count:event_data.last_visit_count,
                clipboard_event_flag: event_data.clipboard_event_flag
            };
        },

        header_title(){
            let header = document.getElementsByClassName('fc-toolbar-chunk')[1];
            header.innerHTML = this.header_display.join(', ');
        },

        initials(fullName) {
            // Create a array from fullName
            let arrName = fullName.split(" ");
      
            // Select the first letter of the name
            let Firstname = fullName.charAt(0).toUpperCase();
      
            // Select the first letter of the lastname
            let lastname = arrName[arrName.length - 1].charAt(0).toUpperCase();
      
            // Return the initials
            return Firstname + lastname ;
          },

        /* here get the all stores data */
        async getStore(){
            this.$session.set('owner_id',this.$store.state.user_id);
            await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);

            if(Object.keys(this.$store.state.stores_data).length > 0){
                this.salon_options = this.$store.state.stores_data;
                if(!this.salon_selected || this.salon_selected == 'null')
                {
                    this.salon_selected = this.salon_options[0];
                    sessionStorage.setItem('filters_salon_selected', JSON.stringify(this.salon_options[0]))
                }
                this.handle_salon_selected ();
                
                this.post_calendar_data.store_id = this.salon_selected.store_id;
//                this.calendarOptions.events = this.loadEvents;

                // this.salon_options.forEach((salon_details)=>
                // {
                //     if(salon_details.store_id == this.salon_selected.store_id)
                //     {
                //         this.header_display[0] = salon_details.store_name.charAt(0).toUpperCase() + salon_details.store_name.slice(1);
                //     }
                // });
                this.header_title();
//                this.getStaff();
//                this.getServices();
                this.applyFilters();
            }
        },

        handle_salon_selected () 
        {
            var salon_details_index = this.salon_options.map(function(item) { return item.store_id; }).indexOf(this.salon_selected.store_id);
            if(salon_details_index === -1)
            {
                this.salon_selected = this.salon_options[0];
                sessionStorage.setItem('filters_salon_selected', JSON.stringify(this.salon_options[0]))
                let _this = this;
                _this.handle_salon_selected()
            }
            else
            {
                this.header_display[0] = this.salon_options[salon_details_index].store_name.charAt(0).toUpperCase() + this.salon_options[salon_details_index].store_name.slice(1);
                this.salon_selected = this.salon_options[salon_details_index];
                sessionStorage.setItem('filters_salon_selected', JSON.stringify(this.salon_options[salon_details_index]));
            }
        },

        async getStaff() {
            let calendarApi = this.$refs.fullCalendar.getApi();
            if (this.salon_selected && this.salon_selected != 'null') {
                await this.$store.dispatch('getStaffByStoreId', [this.$store.state.api, this.salon_selected.store_id]);
                if (Object.keys(this.$store.state.store_staff_ids).length > 0) {
                    if (Object.keys(this.$store.state.store_staff_ids).length > 1) {
                        if (!sessionStorage.getItem('session_calendar_initial_view')) {
                            sessionStorage.setItem('session_calendar_initial_view', 'resourceTimeGridDay')
                            calendarApi.changeView(sessionStorage.getItem('session_calendar_initial_view'));
                        }
                    }else{
                        if (!sessionStorage.getItem('session_calendar_initial_view')) {
                            sessionStorage.setItem('session_calendar_initial_view', 'timeGridWeek')
                            calendarApi.changeView(sessionStorage.getItem('session_calendar_initial_view'));
                        }
                    }
                    let allStaff = this.$store.state.store_staff_ids;
                    this.staff_options = [];
                    var new_staff_selected = [];
                    for (let i = 0; i < allStaff.length; i++) {
                        const selected = this.staff_selected.some(el => el.value === allStaff[i].user_id);
                        this.staff_options.push({
                            value: allStaff[i].user_id,
                            text: allStaff[i].user_first_name + ' ' + allStaff[i].user_last_name,
                            checked: selected
                        })
                        if (selected)
                        {
                            new_staff_selected.push({
                                value: allStaff[i].user_id,
                                text: allStaff[i].user_first_name + ' ' + allStaff[i].user_last_name,
                                checked: selected
                            })
                        }
                    }
                    sessionStorage.setItem('filters_staff_options', JSON.stringify(this.staff_options));
                    if (new_staff_selected.length == 0)
                    {
                        this.staff_selected = [];
                        sessionStorage.removeItem('filters_staff_selected');
                    } else
                    {
                        this.staff_selected = new_staff_selected;
                        sessionStorage.setItem('filters_staff_selected', JSON.stringify(this.staff_selected));
                    }
                    //this.filter_status_selected = [];
                } else {
                    this.staff_options = [];
                }
            }
        },

        async getServices() {

            await this.$store.dispatch('getServiceByStoreId',[this.$store.state.api,this.salon_selected.store_id]);

            if(Object.keys(this.$store.state.store_service_ids).length > 0){
                let allServices = this.$store.state.store_service_ids;
                this.service_options = [];
                for (let i = 0; i < allServices.length; i++) {
                    this.service_options.push({
                        serv_id: allServices[i].serv_id,
                        serv_name: allServices[i].serv_name,
                        checked: false
                    })
                }
                this.service_selected = [];
            }

        },

        async loadEvents(fetchInfo, successCallback) {
            this.$store.state.loader_popup = true
            let _this = this;
            let events = [];
            this.resource_hover=[];
            this.calendarOptions.resources = [];
            this.post_calendar_data.start_date = fetchInfo.startStr.slice(0, 10);
            this.post_calendar_data.end_date = fetchInfo.endStr.slice(0, 10);
            this.$session.set('store_id',this.post_calendar_data.store_id);
            await this.$store.dispatch('staffwise_bookings',[this.$store.state.api,this.post_calendar_data]);
            
            if(Object.keys(this.$store.state.staff_wise_bookings.staffwise_bookings).length > 0){
               
                let staff_wise = _this.$store.state.staff_wise_bookings.staffwise_bookings;
                for (let i = 0; i < staff_wise[0].staff.length; i++) {
                    let offline,staff_start_time,staff_end_time  = '';
                    if(staff_wise[0].staff[i].staff_hours.offline == 0){
                        offline  = false;
                        staff_start_time = staff_wise[0].staff[i].staff_hours.open_time;
                        staff_end_time = staff_wise[0].staff[i].staff_hours.close_time;
                    }else if(staff_wise[0].staff[i].staff_hours.offline == 2){
                        offline  = "24 hours";
                        staff_start_time = "00:00:00";
                        staff_end_time = "24:00:00";
                    }else{
                        offline = true;
                        staff_start_time = "00:00:00";
                        staff_end_time = "00:00:00";
                    }
                    _this.calendarOptions.resources.push({
                        id: staff_wise[0].staff[i].staff_id,
                        title: staff_wise[0].staff[i].staff_first_name,
                        staff_img:staff_wise[0].staff[i].staff_image,
                        store_id : staff_wise[0].staff[i].store_id,
                        staff_offline :offline,
                        businessHours: {
                            startTime: staff_start_time,
                            endTime: staff_end_time,
                            daysOfWeek : [0,1,2,3,4,5,6],     
                        },
                        businessHours_startTime: staff_wise[0].staff[i].staff_hours.open_time,
                        businessHours_endTime: staff_wise[0].staff[i].staff_hours.close_time,
                        user_staff_order : staff_wise[0].staff[i].user_staff_order,
                        staff_name : staff_wise[0].staff[i].staff_first_name,
                        store_start_time : staff_wise[0].business_hours.open_time,
                        store_end_time : staff_wise[0].business_hours.close_time
                         
                    });
                }
                let name;
                for (let i = 0; i < staff_wise.length; i++) {
                    for (let j = 0; j < staff_wise[i].staff.length; j++) {
                        let bookings = staff_wise[i].staff[j].bookings;
                        for (let k = 0; k < bookings.length; k++) {
                            let diffDays = 0
                            let start_time = ''
                            let end_time =''

                            if(bookings[k].last_visited.length > 0){
                                var lastVisit = moment(bookings[k].last_visited[0].last_visited_date, 'YYYY,MM,DD'); 
                                var selectDate = moment(bookings[k].date, 'YYYY,MM,DD');
                                diffDays = selectDate.diff(lastVisit,'days');
                            }

                            if(bookings[k].serv_prebuffertime > 0){
                                start_time = moment(bookings[k].start, "YYYY-MM-DD HH:mm:ss").subtract(bookings[k].serv_prebuffertime, 'minutes').format("YYYY-MM-DD HH:mm:ss")
                            }else{
                                start_time = bookings[k].start
                            }

                            if(bookings[k].serv_postbuffertime > 0){
                                end_time = moment(bookings[k].end, "YYYY-MM-DD HH:mm:ss").add(bookings[k].serv_postbuffertime, 'minutes').format("YYYY-MM-DD HH:mm:ss")
                            }else{
                                end_time = bookings[k].end 
                            }
                            if(bookings[k].service_name == 'Break'){
                                name = bookings[k].first_name ;
                            }else{
                                name = bookings[k].first_name + " " + bookings[k].last_name;                          
                            }
                            if(bookings[k].book_discount_full_amount > -1){
                                bookings[k].book_fullamount = bookings[k].book_discount_full_amount;
                            }
                            events.push({
                                id: bookings[k].id,
                                multi_service_book_id : bookings[k].multi_service_book_id,
                                resourceId: bookings[k].staff_id,
                                start: start_time.replace(' ', 'T'),
                                end: end_time.replace(' ', 'T'),
                                service: bookings[k].service_name,
                                name: name,
                                email:bookings[k].email,
                                vip:bookings[k].is_vip,
                                allergy:bookings[k].has_allergy,
                                form_filled:bookings[k].form_filled,
                                form_url:bookings[k].form_url,
                                banned:bookings[k].is_banned,
                                fullpayment:bookings[k].pay_fullpayment,
                                book_fullamount:bookings[k].book_fullamount,
                                paid_amount:bookings[k].transaction_details[0].total_book_trans_paid_now.toFixed(2), 
                                serv_images:bookings[k].booking_service_images,
                                cust_notes:bookings[k].cust_notes,
                                cust_country_code:bookings[k].country_code,
                                cust_mobile:bookings[k].cust_mobile,
                                cust_profile:bookings[k].cust_picture !=0 ? bookings[k].cust_picture:'',
                                booking_notes:bookings[k].book_staff_note,
                                staff_name:bookings[k].staff_name,
                                staff_id:bookings[k].staff_id,
                                serv_duration : bookings[k].duration,
                                serve_price :bookings[k].service_price,
                                serve_images:bookings[k].booking_service_images,
                                book_status:bookings[k].book_status,
                                start_time:bookings[k].start,
                                end_time:bookings[k].end,
                                prebuffer_time : bookings[k].serv_prebuffertime,
                                postbuffer_time: bookings[k].serv_postbuffertime,
                                last_visit:bookings[k].last_visited,
                                service_date : bookings[k].date,
                                last_visit_days : diffDays,
                                created_date :  moment.utc(bookings[k].created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss'),
                                updated_date :  moment.utc(bookings[k].updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss'),
                               
                            });
                        }
                    }
                }
                successCallback(events);
                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.scrollToTime(this.Constants.SCROLL_TIME);
                this.$store.state.loader_popup = false;
            }
        },
        handel_time_event(){
          this.original_time = true; 
        },
        handlingEventBorder(info){

            if(info.event.extendedProps.book_status == this.Constants.STATUS_BOOKED){
                info.el.style.borderColor = this.Constants.STATUS_BOOKED_EVENT_COLOUR;
            }
            else if(info.event.extendedProps.book_status == this.Constants.STATUS_ARRIVED){
                info.el.style.borderColor = this.Constants.STATUS_ARRIVED_EVENT_COLOUR;
            }
            else if(info.event.extendedProps.book_status == this.Constants.STATUS_COMPLETED){
                info.el.style.borderColor = this.Constants.STATUS_COMPLETED_EVENT_COLOUR;
            }
            else if(info.event.extendedProps.book_status == this.Constants.STATUS_NO_SHOW){
                info.el.style.borderColor = this.Constants.STATUS_NO_SHOW_EVENT_COLOUR;
            }
            else if(info.event.extendedProps.book_status == this.Constants.STATUS_EARLY_CANCELLED){
                info.el.style.borderColor = this.Constants.STATUS_EARLY_CANCELLED_EVENT_COLOUR;
            }
            else if(info.event.extendedProps.book_status == this.Constants.STATUS_LATE_CANCELLED){
                info.el.style.borderColor = this.Constants.STATUS_LATE_CANCELLED_EVENT_COLOUR;
            }
            
            if(info.event.extendedProps.service == 'Break'){
                info.el.style.backgroundColor = "#FDF3E9";
                info.el.style.border = '0px solid #DED5C4';
            }

            document.getElementsByClassName('fc-timegrid-event-harness-inset').forEach(overlap_event => {
                if(overlap_event.getElementsByClassName('break_event').length > 0){
                    if(overlap_event.style.zIndex != 0){
                        overlap_event.style.zIndex = 0;
                    }
                }else{
                    overlap_event.style.zIndex = 1;
                }

                if(overlap_event.style.left > '20%'){
                    overlap_event.style.left = '20%';
                }

                if(overlap_event.style.left == '0%'){
                    overlap_event.style.width = '80%';
                }

                if(overlap_event.style.right != '0%'){
                    overlap_event.style.width = '80%';
                }else{
                    overlap_event.style.left = '20%';
                    overlap_event.style.width = '80%';
                }
               
            })

            document.getElementsByClassName('fc-timegrid-event-harness').forEach(overlap_event => {
                if(overlap_event.style.left == '0%'){
                    if(overlap_event.style.right != '0%'){
                        overlap_event.style.width = '80%';
                    }
                }
            })

            this.on_event_drag_to_clipboard(info);
        },

        resourceMount (info) {

            info.el.firstChild.hidden = true;
            
            let start_time = moment(info.resource.extendedProps.businessHours_startTime,'HH:mm:ss').format('HH:mm');
            let end_time = moment(info.resource.extendedProps.businessHours_endTime,'HH:mm:ss').format('HH:mm');

            let store_open_time = moment(info.resource.extendedProps.store_start_time,'HH:mm:ss').format('HH:mm');
            let store_end_time = moment(info.resource.extendedProps.store_end_time,'HH:mm:ss').format('HH:mm');

            let default_start_time = moment(this.Constants.DEFAULT_STORE_OPEN_TIME,'HH:mm:ss').format('HH:mm');
            let default_end_time = moment(this.Constants.DEFAULT_STORE_CLOSE_TIME,'HH:mm:ss').format('HH:mm');

            if(info.resource.extendedProps.staff_img){
                if(info.resource.extendedProps.staff_offline == true){
                    info.el.innerHTML = "<span class='staff_img_div'><img class='border_ash' src=" + info.resource.extendedProps.staff_img + "></span><span class='staff_name_div'>" +info.resource.title+ "&nbsp; <small class='ash'> Offline</small></span>"
                }else if(info.resource.extendedProps.staff_offline == "24 hours"){
                    info.el.innerHTML = "<span class='staff_img_div'><img src=" + info.resource.extendedProps.staff_img + "></span><span class='staff_name_div'>" +info.resource.title+ "&nbsp; <small class='ash'> Online</small></span>"
                }else if(start_time == "00:00" && end_time == "00:00"){
                    if (store_open_time == "00:00" && store_end_time == "00:00" ) {
                        info.el.innerHTML = "<span class='staff_img_div'><img src=" + info.resource.extendedProps.staff_img + "></span><span class='staff_name_div'>" +info.resource.title + "&nbsp; <small class='ash'>" + default_start_time + ' - ' + default_end_time + "</small></span>";

                    }else{
                        info.el.innerHTML = "<span class='staff_img_div'><img src=" + info.resource.extendedProps.staff_img + "></span><span class='staff_name_div'>" +info.resource.title + "&nbsp; <small class='ash'>" + store_open_time + ' - ' + store_end_time + "</small></span>";
                    }
                    
                }else{
                    info.el.innerHTML = "<span class='staff_img_div'><img src=" + info.resource.extendedProps.staff_img + "></span><span class='staff_name_div'>" +info.resource.title + "&nbsp; <small class='ash'>" + start_time + ' - ' + end_time + "</small></span>"
                }
               
            }
            else{
                let img = require('@/assets/images/bg_logo.svg')
                if(info.resource.extendedProps.staff_offline == true){
                    info.el.innerHTML = "<span class='staff_img_div'><img class='p-0 border_ash' src="+ img +"></span><span class='staff_name_div'>" +info.resource.title+ "&nbsp;<small class='ash'> Offline</small></span>"
                }else if(info.resource.extendedProps.staff_offline == "24 hours"){
                    info.el.innerHTML = "<span class='staff_img_div'><img class='p-0' src="+ img +"></span></span><span class='staff_name_div'>" +info.resource.title+ "&nbsp;<small class='ash'> Online</small></span>"
                }else if(start_time == "00:00" && end_time == "00:00"){
                    if (store_open_time == "00:00" && store_end_time == "00:00" ) {
                        info.el.innerHTML= "<span class='staff_img_div'><img class='p-0' src="+ img +"></span></span><span class='staff_name_div'>" +info.resource.title + "&nbsp;<small class='ash'>" + default_start_time + ' - ' + default_end_time + "</small></span>";

                    }else{
                        info.el.innerHTML= "<span class='staff_img_div'><img class='p-0' src="+ img +"></span></span><span class='staff_name_div'>" +info.resource.title + "&nbsp;<small class='ash'>" + store_open_time + ' - ' + store_end_time + "</small></span>";
                    }
                   
                }else{
                    info.el.innerHTML= "<span class='staff_img_div'><img class='p-0' src="+ img +"></span></span><span class='staff_name_div'>" +info.resource.title + "&nbsp;<small class='ash'>" + start_time + ' - ' + end_time + "</small></span>"; 
                }
            }

            this.resource_hover.push(info);
            this.click_staff_offline[this.resource_hover.length - 1] = !info.resource.extendedProps.staff_offline;
            this.resourceWidth();
        },

        eventRefetch(){
            this.$store.state.loader_popup = true
            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.refetchEvents();
            
            let _this = this
            window.setTimeout( function(){
                _this.onSideDivResize()
            },100)   

        },

        eventMoreInfo(mouseEnterInfo) {
            if( (typeof mouseEnterInfo.event.extendedProps.clipboard_event_flag == 'undefined') && (mouseEnterInfo.event.extendedProps.service != 'Break') )
            {
                for(let i=0 ; i < this.status.length ; i++){
                    if(mouseEnterInfo.event.extendedProps.book_status == this.book_status[i].status_id){
                        this.status_selected = this.book_status[i]
                    }
                }
                this.event_hover.push(mouseEnterInfo);
                this.$store.state.book_id.push(mouseEnterInfo.event.id);
            }
        }, 

        todayDate(){
            this.date_picker.value = moment(new Date()).format('YYYY-MM-DD');
        },

        dayView(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.changeView('resourceTimeGridDay');
            calendarApi.refetchEvents();
        },

        nextWeek(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(7, "days").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },

        prevWeek(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(7, "days").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },

        next2Week(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(14, "days").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },
        nextDate(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = '';
            if(calendarApi.view.type == 'resourceTimeGridDay'){
                 date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(1, "day").format('YYYY-MM-DD');
            }
            else if(calendarApi.view.type == 'timeGridWeek'){
                date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(1, "week").format('YYYY-MM-DD');
            }
            else if(calendarApi.view.type == 'dayGridMonth'){
                date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(1, "month").format('YYYY-MM-DD');
            }
            this.date_picker.value = date;
        },
        prevDate(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = '';
            if(calendarApi.view.type == 'resourceTimeGridDay'){
                 date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(1, "day").format('YYYY-MM-DD');
            }
            else if(calendarApi.view.type == 'timeGridWeek'){
                date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(1, "week").format('YYYY-MM-DD');
            }
            else if(calendarApi.view.type == 'dayGridMonth'){
                date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(1, "month").format('YYYY-MM-DD');
            }
            this.date_picker.value = date;
        },
        prev2Week(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(14, "days").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },

        next2Month(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').add(2, "months").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },

        prev2Month(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            let date = moment(calendarApi.getDate(), 'dd-mm-yyyy').subtract(2, "months").format('YYYY-MM-DD');
            this.date_picker.value = date;
        },

        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },
        
        handleDateSelect(selectInfo) {
            var start_time = utils.convert_datetime_to_bookjoy_time_format(selectInfo.startStr)
            var end_time   = utils.convert_datetime_to_bookjoy_time_format(selectInfo.endStr)
            var duration   = utils.time_duration_in_min(start_time, end_time)
            if(duration <= 5){
				if(selectInfo.view.type == 'dayGridMonth') 
				{
					var today = new Date();
					start_time = today.getHours() + ":" + utils.round_to_near_5min(today.getMinutes())
				}
                this.$session.set('selected_date',selectInfo.startStr);
                this.$session.set('service_start_time',start_time);
                this.$session.set('staff_id',selectInfo.resource ? selectInfo.resource.id : this.staff_selected.length == 1 ? this.staff_selected[0].value : this.staff_clicked= this.staff_options[0].value);
                this.$session.set('staff_selected',true);
                this.$session.set('rebook',false);
                this.$router.push('/newbooking');
            }
            else{
                if(selectInfo.resource){
                   this.staff_clicked = selectInfo.resource.id;
                }
                else if(this.staff_selected.length == 1){
                    this.staff_clicked= this.staff_selected[0].value    
                }
                else{  
                    this.staff_clicked= this.staff_options[0].value
                }

                this.$session.set('selected_break_date',selectInfo.startStr);
                this.break_start_time = start_time;
                this.break_end_time   = end_time;
                this.staff_break_popup = true;
            }
        },
        handleEventClick(clickInfo) {  
            if(clickInfo.event.extendedProps.service == 'Break')
            {
                this.edit_break_id              = clickInfo.event.id;
                this.edit_break_date            = clickInfo.event.extendedProps.service_date;
                this.edit_break_staff_selected  = clickInfo.event.extendedProps.staff_id;
                this.edit_break_start_time      = clickInfo.event.extendedProps.start_time;
                this.edit_break_end_time        = clickInfo.event.extendedProps.end_time;                
                this.edit_break_notes           = clickInfo.event.extendedProps.booking_notes;
                this.edit_break_created_date   = clickInfo.event.extendedProps.created_date;
                this.edit_break_updated_date   = clickInfo.event.extendedProps.updated_date;
                this.edit_break_popup           = true;
            }
            else{
                // this.$session.destroy()
                this.$session.set('book_id',clickInfo.event.id)
                this.$session.set('multi_book_id',clickInfo.event.extendedProps.multi_service_book_id)
                this.$router.push('/viewbooking')
            }              
        },

        handleEvents(events) {
            let date = this.$refs.fullCalendar.$options.calendar.currentData.currentDate
            let current_date = moment.utc(date).toString().split(" ").splice(0,4).join(' ')
            this.$store.state.selected_date = moment(current_date).format('yyyy-MM-DD');
            this.currentEvents = events
            let calendarApi = this.$refs.fullCalendar.getApi();
            this.day_button_design();
            
            if(calendarApi.view.type == 'resourceTimeGridDay'){
                if(this.$store.state.selected_date == moment(new Date()).format("YYYY-MM-DD")){
                    this.calendarOptions.headerToolbar.left = 'PrevWeekButton,prev title next,NextWeekButton,DisableTodayButton';
                }
                else{
                    this.calendarOptions.headerToolbar.left = 'PrevWeekButton,prev title next,NextWeekButton,TodayButton';
                }
                this.calendarOptions.headerToolbar.right ='DayButton,timeGridWeek,dayGridMonth,ClipboardButton,FilterButton';

                this.clipboard_button_enable_or_disable('enable')
            }
            else if(calendarApi.view.type == 'timeGridWeek'){
                if(this.$store.state.store_staff_ids.length === 1){
                    let single_staff = [{
                        value: this.$store.state.store_staff_ids[0].user_id,
                        text: this.$store.state.store_staff_ids[0].user_first_name + ' ' + this.$store.state.store_staff_ids[0].user_last_name,
                        checked: true
                    }];
                    this.staff_selected = single_staff;
                    sessionStorage.setItem('filters_staff_selected',JSON.stringify(single_staff))
                }
                this.calendarOptions.businessHours = [];
                if (sessionStorage.getItem('filters_staff_selected') === null) {
                    console.log("Staff not selected")
                  }else{
                    var selected_staff = JSON.parse(sessionStorage.getItem('filters_staff_selected'));
                    if(selected_staff.length == 1){
                        var calender_data = this.$store.state.staff_wise_bookings.staffwise_bookings;
                        
                        var staff_working_hours = {
                            daysOfWeek: [],
                            startTime: '',
                            endTime: ''
                        }
                        var index = 0;
                        this.calendarOptions.businessHours = [];
                        if(calender_data != undefined){
                            calender_data.forEach(staff_data => {
                                if(!staff_data.staff[0].staff_hours.open_time || !staff_data.staff[0].staff_hours.close_time){
                                    staff_working_hours.startTime = '00:00:00';
                                    staff_working_hours.endTime = '00:00:00';
                                }
                                else{
                                    staff_working_hours.startTime = staff_data.staff[0].staff_hours.open_time;
                                    staff_working_hours.endTime = staff_data.staff[0].staff_hours.close_time;
                                }
                                staff_working_hours.daysOfWeek.push(index);
                                this.calendarOptions.businessHours.push(staff_working_hours);
                                index++;
                                staff_working_hours = {
                                    daysOfWeek: [],
                                    startTime: '',
                                    endTime: ''
                                }
                            });
                        }
                    }
                    
                }

                this.calendarOptions.headerToolbar.left = 'Prev2WeekButton,prev title next,Next2WeekButton';
                this.calendarOptions.headerToolbar.right ='DayButton,timeGridWeek,dayGridMonth,ClipboardButton,FilterButton';
                this.clipboard_button_enable_or_disable('disable')
            }
            else if(calendarApi.view.type == 'dayGridMonth'){
                this.calendarOptions.headerToolbar.left = 'Prev2MonthButton,prev title next,Next2MonthButton';
                this.calendarOptions.headerToolbar.right ='DayButton,timeGridWeek,dayGridMonth,ClipboardButton,FilterButton';
                this.clipboard_button_enable_or_disable('disable')
                this.event_hover_placement = 'left';
            }
            if(sessionStorage.getItem('session_calendar_initial_view')){
                sessionStorage.setItem('session_calendar_initial_view',calendarApi.view.type);
            }

        },

        fabStatusChange() {
            this.fab_icon_popup = false;
        },

        filterView() {
            this.clipboard_block = false;
            this.filter_view = true;
            this.calendar_col('col-9');   
        },

        closeFilter() {
            this.filter_view = false;
            this.calendar_col('col-12');
        },

        clipboard_open() {
            this.filter_view = false;            
            this.clipboard_block = true;
            this.calendar_col('col-9');
        },

        clipboard_close() {
            if(ClipboardEventsJS.check_clipboard_events('length') == 0) this.clear_events_in_clipboard();
            else this.clipboard_events_clear_model = true;
        },

        clear_events_in_clipboard () {
            this.clipboard_events_clear_model = false;            
            this.clipboard_events = [];
            sessionStorage.setItem("droped_event", JSON.stringify([]));
            this.clipboard_button();
            this.minimize_clipboard();
            this.eventRefetch();
        },

        minimize_clipboard() {
            this.clipboard_block = false;
            if(this.filter_view == false) this.calendar_col('col-12');
        },

        calendar_col(col) {
            if(this.calendar_size == col) return;
            this.calendar_size = col;

            let _this = this
            window.setTimeout( function(){
                _this.onSideDivResize()
            },100)  
        },

        getPickDate(info) {
            let calendarApi = this.$refs.fullCalendar.getApi();
            if (info.selectedYMD){
                calendarApi.gotoDate(info.selectedYMD);
            }
        },
        
        onSelect(option,flag_type) {
            if(flag_type == 0){
                let index = this.staff_options.findIndex(item => item.text==option.text);
                this.staff_options[index].checked = true;
            }
            else if(flag_type == 1){
                let index = this.service_options.findIndex(item => item.serv_name==option.serv_name);
                this.service_options[index].checked = true;
            }
            else if(flag_type == 2){
                let index = this.status.findIndex(item => item.status_name==option.status_name);
                this.status[index].checked = true;
            }
        },
        onRemove(option,flag_type) {
            if(flag_type == 0){
                let index = this.staff_options.findIndex(item => item.text==option.text);
                this.staff_options[index].checked = false;
            }
            else if(flag_type == 1){
                let index = this.service_options.findIndex(item => item.serv_name==option.serv_name);
                this.service_options[index].checked = false;
            }
            else if(flag_type == 2){
                let index = this.status.findIndex(item => item.status_name==option.status_name);
                this.status[index].checked = false;
            }
        },

        update_events(close_modal)
        {
            this[close_modal] = false
            this.eventRefetch()
        },

        resetFilter(all_staff_apply_filter){
            this.filter_status_selected = [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'checked' :true },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'checked' :true },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'checked' :true }
            ];
            this.status = [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'checked' :true },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'checked' :true },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'checked' :true },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'checked' :false },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'checked' :false }
            ];
            this.staff_selected = [];

            this.staff_options.forEach((staff)=>{
                staff.checked = false;
            })

            this.cancel_bookings = false;
            if(all_staff_apply_filter === 'true'){
                this.applyFilters();
            }
        },

        async applyFilters(staff_id,view_type) {
            
            let calendarApi = this.$refs.fullCalendar.getApi();
            
            if(view_type){
                this.post_calendar_data.staff_id = staff_id;

                if (!this.staff_selected.length) {
                    this.staff_options.forEach((staff)=>{
                        if(staff.value == staff_id){
                            staff.checked = true
                            this.staff_selected.push(staff);
                        }
                    });
                }else{
                    this.staff_selected = []
                    this.staff_options.forEach((staff)=>{
                        if(staff.value == staff_id){
                            staff.checked = true;
                            this.staff_selected.push(staff);
                        }
                        else{
                            staff.checked = false
                        }
                    });
                }
                this.header_display[1] = '1 Stylist';
                sessionStorage.setItem('filters_staff_selected', JSON.stringify(this.staff_selected));
            }else{
                if(!this.salon_selected){
                    this.post_calendar_data.store_id = this.$store.state.stores_data[0]
                }else{
                    this.post_calendar_data.store_id = this.salon_selected.store_id;
                }
                sessionStorage.setItem('filters_salon_selected', JSON.stringify(this.salon_selected))
                this.post_calendar_data.book_type = this.booktype_selected;
                this.salon_options.forEach((value)=>{
                    if(value.store_id === this.salon_selected.store_id){
                        this.header_display[0] = value.store_name.charAt(0).toUpperCase() + value.store_name.slice(1);
                    }
                });

                let selected_staff = [];
                if(this.staff_selected != ''){
                    for(let i=0; i < this.staff_selected.length; i++){
                        selected_staff.push(this.staff_selected[i].value);
                    }
                    sessionStorage.setItem('filters_staff_selected', JSON.stringify(this.staff_selected));
                    this.post_calendar_data.staff_id = selected_staff;
                    this.header_display[1] = selected_staff.length == 1 ?  selected_staff.length + ' Stylist' : selected_staff.length +' Stylists';
                }else{
                    this.post_calendar_data.staff_id = null;
                    sessionStorage.removeItem('filters_staff_selected')
                    this.header_display[1] = 'All stylists';
                }

                await this.getStaff();
                if(this.staff_selected.length != selected_staff.length)
                {
                    this.post_calendar_data.staff_id = null;
                    sessionStorage.removeItem('filters_staff_selected')
                    this.header_display[1] = 'All stylists';
                }

                if(this.booktype_selected){
                    this.header_display[2] = this.booktype_selected;
                }else{
                    this.header_display[2] = 'Services';
                }

                if(this.service_selected != ''){
                    let selected_service = [];
                    for(let j=0; j < this.service_selected.length; j++){
                        selected_service.push(this.service_selected[j].serv_id) ;
                    }
                    this.post_calendar_data.serv_id = selected_service;
                }else{
                    this.post_calendar_data.serv_id = null;
                }

                if(this.filter_status_selected.length > 0){
                    sessionStorage.setItem('filters_filter_status_selected', JSON.stringify(this.filter_status_selected));
                    let selected_status = [];
                    for(let k=0; k < this.filter_status_selected.length; k++){
                        selected_status.push(this.filter_status_selected[k].status_id) ;
                    }
                  
                    this.post_calendar_data.book_status = selected_status;
                }else{
                    sessionStorage.removeItem('filters_filter_status_selected')
                    this.post_calendar_data.book_status = null;
                }

                if(this.cancel_bookings){
                    if(!this.post_calendar_data.book_status){
                        this.post_calendar_data.book_status = null;
                        sessionStorage.removeItem('cancelled_bookings');
                    }else{
                        sessionStorage.setItem('cancelled_bookings', true);
                        this.post_calendar_data.book_status.push(this.Constants.STATUS_EARLY_CANCELLED);
                        this.post_calendar_data.book_status.push(this.Constants.STATUS_LATE_CANCELLED);
                    }   
                }else{
                    sessionStorage.removeItem('cancelled_bookings');
                    if(!this.post_calendar_data.book_status) this.allStatusWithoutCancelled();
                }

                sessionStorage.setItem('filters_status', JSON.stringify(this.status));
            }
            
            this.header_title();
            this.filter_view = false;
            if(this.clipboard_block){
                this.calendar_col('col-9');
            }else{
                this.calendar_col('col-12');
            }
            if(staff_id && view_type === 'day'){
                this.event_hover_placement = 'left';
                calendarApi.refetchEvents();
                return true;
            }else if(staff_id && view_type === 'week'){
                this.event_hover_placement = 'left';
                calendarApi.changeView('timeGridWeek');
                return true;
            }else if(staff_id && view_type === 'month'){
                this.event_hover_placement = 'left';
                calendarApi.changeView('dayGridMonth');
                return true;
            }else{
                this.event_hover_placement = 'right';
            }
            if(this.first_load_events_data){
                this.first_load_events_data = false;
                this.calendarOptions.events = this.loadEvents;
            }else{
                this.eventRefetch();
            }
        },
        allStatusWithoutCancelled(){
            var reset_obj = [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'checked' :true },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'checked' :true },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'checked' :true },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'checked' :true },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'checked' :true }
            ];
            this.filter_status_selected = reset_obj;
            sessionStorage.setItem('filters_filter_status_selected', JSON.stringify(reset_obj));
            this.status = reset_obj;
            this.post_calendar_data.book_status = [this.Constants.STATUS_BOOKED, this.Constants.STATUS_ARRIVED, this.Constants.STATUS_COMPLETED, this.Constants.STATUS_NO_SHOW, this.Constants.STATUS_LATE_CANCELLED];
        },

        staffAvailable(index,store_id,date,end,start,staff_id,offline,store_open_time,store_close_time){
            let staff_offline = '';
            if (this.click_staff_offline[index]) {
                staff_offline = 1
                this.calendarOptions.resources[index].businessHours = {
                    startTime: '00:00:00',
                    endTime: '00:00:00',
                    daysOfWeek:[0,1,2,3,4,5,6]
                }
                let te = document.getElementsByClassName('staff_name_div')[index];
                te.getElementsByClassName('ash')[0].innerHTML = 'Offline';
                let staff_img = document.getElementsByClassName('staff_img_div');
                staff_img[index].children[0].className = 'border_ash';
            } else {
                staff_offline = 0; 
                let set_start='';
                let set_end = '';
                let te = document.getElementsByClassName('staff_name_div')[index];
                if(start == '00:00:00' && end == '00:00:00'){
                   
                    if(store_open_time == '00:00:00' && store_close_time == '00:00:00' ){
                        set_start =   moment(this.Constants.DEFAULT_STORE_OPEN_TIME, 'HH:mm:ss').format('HH:mm');
                        set_end   =   moment(this.Constants.DEFAULT_STORE_CLOSE_TIME, 'HH:mm:ss').format('HH:mm');
                        start     =   this.Constants.DEFAULT_STORE_OPEN_TIME;
                        end       =   this.Constants.DEFAULT_STORE_CLOSE_TIME;
                       
                    }else{
                        set_start =  moment(store_open_time, 'HH:mm:ss').format('HH:mm');
                        set_end   =  moment(store_close_time, 'HH:mm:ss').format('HH:mm');
                        start     =  store_open_time;
                        end       =  store_close_time;
                    }
                   
                }else{
                    set_start     =  moment(start, 'HH:mm:ss').format('HH:mm');
                    set_end       =  moment(end, 'HH:mm:ss').format('HH:mm');
                }
                te.getElementsByClassName('ash')[0].innerHTML = `${set_start} - ${set_end}`;
                this.calendarOptions.resources[index].businessHours = {
                    startTime: start,
                    endTime: end,
                    daysOfWeek:[0,1,2,3,4,5,6]
                }
                
                let staff_img = document.getElementsByClassName('staff_img_div');
                staff_img[index].children[0].className = '';
            }
            
            this.$store.dispatch('edit_staff_hrs',[
                this.$store.state.api,store_id,staff_id,date,start,end,this.$store.state.user_id,'',staff_offline
            ])
            this.calendarOptions.resources[index].staff_offline = offline;
        },

        openImageModel(imageBookingId, imagePopupName, multi_book_id, show_upload) {
            this.imageBookingId     = imageBookingId;
            this.imagePopupName     = imagePopupName;
            this.imageMultiBookId   = multi_book_id;
            this.show_upload_picture = show_upload;
            this.service_image_crop_model = true;
        },
        staff_break_hours(staff_id){
            var today = new Date();
            this.break_start_time = today.getHours() + ":" + utils.round_to_near_5min(today.getMinutes());
            this.break_end_time   = today.getHours() + ":" + (utils.round_to_near_5min(today.getMinutes()) + 10);
            this.staff_break_popup = true;
            this.staff_clicked = staff_id;

        },
        staffbreakStatusChange(){
            this.staff_break_popup = false;
        },
        staff_work_hours(staff_id,store_open_time,store_close_time){
            this.staff_clicked = staff_id;
            let _this = this;
            if(Object.keys(this.$store.state.staff_wise_bookings.staffwise_bookings).length > 0){
                let staff_wise = _this.$store.state.staff_wise_bookings.staffwise_bookings;
                for (let i = 0; i < staff_wise[0].staff.length; i++) {
                    if(staff_wise[0].staff[i].staff_id == staff_id)
                    {
                        if(staff_wise[0].staff[i].staff_hours.open_time == '00:00:00' &&  staff_wise[0].staff[i].staff_hours.close_time == '00:00:00'){
                            if(store_open_time == '00:00:00' && store_close_time == '00:00:00' ){
                                this.staff_selected_start_time =  this.Constants.DEFAULT_STORE_OPEN_TIME;
                                this.staff_selected_end_time   =  this.Constants.DEFAULT_STORE_CLOSE_TIME; 
                            }else{
                                this.staff_selected_start_time = store_open_time;
                                this.staff_selected_end_time   = store_close_time;
                            }    
                        }else{
                            this.staff_selected_start_time = staff_wise[0].staff[i].staff_hours.open_time;
                            this.staff_selected_end_time = staff_wise[0].staff[i].staff_hours.close_time;
                        }
                        
                    }
                }
            }
            this.staff_work_popup = true;
        },
        staffworkStatusChange(){
            this.staff_work_popup = false;
            this.eventRefetch();
        },
        selectStaffChange(staff_change_id){
            this.staff_selected = staff_change_id;
        },
        status_change(selected,bookid,multiid){
            // this.$session.destroy()
            
            this.$session.set('book_id',bookid)
            this.$session.set('multi_book_id',multiid)

            if(selected == this.Constants.STATUS_BOOKED){
                this.$store.state.booked_popup = true;
            }
            else if(selected == this.Constants.STATUS_ARRIVED){
                this.$store.state.arrived_popup = true;
            }
            else if(selected == this.Constants.STATUS_COMPLETED){
                this.$store.state.completed_popup = true;
            }
            else if(selected == this.Constants.STATUS_NO_SHOW){
                this.$store.state.noshow_popup = true;
            }
            else if(selected == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.cancel_popup = true;
            }
            else if(selected == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.latecancel_popup = true;
            }
        },

        changeValue(type){
            
            if(type == this.Constants.STATUS_BOOKED){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.booked_popup = false;
            }
            else if(type == this.Constants.STATUS_ARRIVED){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.arrived_popup = false;
            }
            else if(type == this.Constants.STATUS_COMPLETED){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.completed_popup = false;
            }
            else if(type == this.Constants.STATUS_NO_SHOW){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.noshow_popup = false;
            }
            else if(type == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.cancel_popup = false;
            }
            else if(type == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.book_status = this.status_selected.status_id
                this.$store.state.latecancel_popup = false;
            }
            this.eventRefetch();
            this.status_selected = this.book_status[0];

        },
        cancelStatusChange(type){

            this.status_selected = this.book_status[0];
                
            if(type == this.Constants.STATUS_BOOKED){
                this.$store.state.booked_popup = false;
            }
            else if(type == this.Constants.STATUS_ARRIVED){
                this.$store.state.arrived_popup = false;
            }
            else if(type == this.Constants.STATUS_COMPLETED){
                this.$store.state.completed_popup = false;
            }
            else if(type == this.Constants.STATUS_NO_SHOW){
                this.$store.state.noshow_popup = false;
            }
            else if(type == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.cancel_popup = false;
            }
            else if(type == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.latecancel_popup = false;
            }

        },

        preBuffer(event_start, pre_min){
            return moment(event_start, 'YYYY-MM-DD HH:mm:ss').subtract(pre_min,'minutes').format("h:mm A")
        },

        postBuffer(event_end, post_min){
            return moment(event_end, 'YYYY-MM-DD HH:mm:ss').add(post_min,'minutes').format("h:mm A")
        },
        manageEndTime(end_time,pre_buffer,post_buffer){
            return moment(end_time).subtract({minutes:pre_buffer+post_buffer});
        },
        close_all_hover_popover(){
            this.$root.$emit('bv::hide::popover');
            document.querySelector("body").style.overflow = 'hidden';
        },
        
        enable_body_scroll(){
            document.querySelector("body").style.overflow = 'visible';
        }
    },
    filters:{
        time_12hr(time){
            return moment(time.split(' ')[1] , 'HH:mm:ss').format("hh:mm A");
        },

        date_to_time(date_time){
            return moment(date_time , 'YYYY-MM-DD HH:mm:ss').format("h:mm");
        },

        date_time_meridian(date_time){
            return moment(date_time , 'YYYY-MM-DD HH:mm:ss').format("h:mm A");
        },

        content_less: function(content){
            return content.substr(0, 150);
        }
    }
}

var clipboardArea = function(x, y) {
    var is_clipboard_area   = document.getElementById("clipboard").getBoundingClientRect();
    var left                = is_clipboard_area.left;
    var right               = is_clipboard_area.left + is_clipboard_area.width;
    var top                 = is_clipboard_area.top;
    var bottom              = is_clipboard_area.top + is_clipboard_area.height;
    if(x >= left && y >= top && x <= right && y <= bottom)
    { 
        return true; 
    }
    return false;
}
